import { render, staticRenderFns } from "./ReactivateDealer.vue?vue&type=template&id=462c60f8&"
import script from "./ReactivateDealer.vue?vue&type=script&lang=js&"
export * from "./ReactivateDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports